import { render, staticRenderFns } from "./SiginOut.vue?vue&type=template&id=39348802&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39348802')) {
      api.createRecord('39348802', component.options)
    } else {
      api.reload('39348802', component.options)
    }
    module.hot.accept("./SiginOut.vue?vue&type=template&id=39348802&", function () {
      api.rerender('39348802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/oicd/SiginOut.vue"
export default component.exports